import React from 'react';

function FormMessage(props) {
    let { apiSuccess, firstName, lastName } = props;

    let message = apiSuccess ?
        `Thank you, ${firstName} ${lastName}! A W. B. Mason representative will be in touch soon.` :
        "Oops! There was a problem submitting your request. Please try again or call W.B. Mason at 508-436-1036 to place this request.";

    return (
        <div className={`col-6 m-auto message text-center ${apiSuccess ? "success" : "error"} `}>
            {message}
        </div>
    );
};

export default FormMessage;